import { render, staticRenderFns } from "./InstagramInstantwinPrizeEditDialog.vue?vue&type=template&id=8aad1ff0&scoped=true"
import script from "./InstagramInstantwinPrizeEditDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramInstantwinPrizeEditDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramInstantwinPrizeEditDialog.vue?vue&type=style&index=0&id=8aad1ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aad1ff0",
  null
  
)

export default component.exports